<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-2" (click)="submit()">Zapisz</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<div class="container mb-4">
	<form class="" (submit)="submit()">
		<div class="card my-4">
			<div class="card-body row">
				<h5 class="card-title col-sm-12">Opiekun</h5>
				<div class="mb-3 col-sm-12">
					<ng-select
						name="owner"
						[(ngModel)]="offer.owner"
						[items]="users"
						placeholder="(wybierz)"
						bindLabel="name"
						bindValue="id"
					></ng-select>
				</div>
			</div>
		</div>
		<div class="card my-4">
			<div class="card-body row">
				<h5 class="card-title col-sm-12">
					Różnice dat
					<div class="btn btn-primary btn-sm" (click)="submit(1)">
						<i class="fas fa-sync"></i> Zapisz i odśwież terminy
					</div>
				</h5>
				<div class="mb-3 col-sm-6">
					<label>Delta zakwaterowanie</label>
					<input
						type="number"
						min="0"
						class="form-control"
						name="deltaAccommodation"
						[(ngModel)]="offer.deltaAccommodation"
					/>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Delta wykwaterowanie</label>
					<input
						type="number"
						min="0"
						class="form-control"
						name="deltaEviction"
						[(ngModel)]="offer.deltaEviction"
					/>
				</div>
			</div>
		</div>
		<div class="card my-4">
			<div class="card-body row">
				<h5 class="card-title col-sm-12">Godziny</h5>
				<div class="mb-3 col-sm-6">
					<label>Godzina z Poznania</label>
					<input type="time" class="form-control" name="poznanFromHour" [(ngModel)]="offer.poznanFromHour" />
					<select class="form-control" name="poznanFromDays" [(ngModel)]="offer.poznanFromDays">
						<option value="0">0 dni</option>
						<option value="1">+1 dzień</option>
						<option value="2">+2 dni</option>
					</select>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Godzina do Poznania</label>
					<input type="time" class="form-control" name="poznanToHour" [(ngModel)]="offer.poznanToHour" />
					<select class="form-control" name="poznanToDays" [(ngModel)]="offer.poznanToDays">
						<option value="0">0 dni</option>
						<option value="1">-1 dzień</option>
						<option value="2">-2 dni</option>
					</select>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Godzina Rozpoczęcia programu</label>
					<input
						type="time"
						class="form-control"
						name="programBeginHour"
						[(ngModel)]="offer.programBeginHour"
					/>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Godzina zakończenia programu</label>
					<input type="time" class="form-control" name="programEndHour" [(ngModel)]="offer.programEndHour" />
				</div>
			</div>
		</div>
		<div class="card my-4">
			<div class="card-body row">
				<h5 class="card-title col-sm-12">Finanse</h5>
				<div class="mb-3 col-sm-6">
					<label>Koszty: Tranport + Pilot + Przewodniki + Noclegi dla załogi</label>
					<app-price-with-currency
						[(value)]="offer.costsFixed"
						[(currency)]="offer.costsFixedCurrency"
						[currencies]="currencies"
					></app-price-with-currency>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Koszty: Zakwaterowanie + Bilety</label>
					<app-price-with-currency
						[(value)]="offer.costsVariable"
						[(currency)]="offer.costsVariableCurrency"
						[currencies]="currencies"
					></app-price-with-currency>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Opłaty programowe / klimatyczne</label>
					<select class="form-control" name="programFeesType" [(ngModel)]="offer.programFeesType">
						<option value="0">(wybierz)</option>
						<option value="1">za noc</option>
						<option value="2">za wycieczkę</option>
					</select>
					<app-price-with-currency
						[(value)]="offer.programFees"
						[(currency)]="offer.programFeesCurrency"
						[currencies]="currencies"
					></app-price-with-currency>
				</div>
				<div class="mb-3 col-sm-6">
					<label>Planowane płatności (per uczestnik, płacone z biura)</label>
					<select class="form-control" name="plannedPaymentsType" [(ngModel)]="offer.plannedPaymentsType">
						<option value="0">(wybierz)</option>
						<option value="1">za noc</option>
						<option value="2">za wycieczkę</option>
					</select>
					<app-price-with-currency
						[(value)]="offer.plannedPayments"
						[(currency)]="offer.plannedPaymentsCurrency"
						[currencies]="currencies"
					></app-price-with-currency>
				</div>
			</div>
		</div>
		<div class="card my-4">
			<div class="card-body row">
				<h5 class="card-title col-sm-12">Konfiguracja ceny aktualnej</h5>
				<div class="mb-3 col-sm-6">
					<label for="queryRoom">Pokój Bazowy</label>
					<ng-select
						id="queryRoom"
						name="queryRoom"
						[(ngModel)]="offer.queryRoom"
						[items]="rooms"
						placeholder="(wybierz)"
						bindLabel="name"
						bindValue="id"
					></ng-select>
				</div>
				<div class="mb-3 col-sm-6">
					<label for="queryPriceList">Cennik Bazowy</label>
					<ng-select
						id="queryPriceList"
						name="queryPriceList"
						[(ngModel)]="offer.queryPriceList"
						[items]="priceLists"
						placeholder="(wybierz)"
						bindLabel="name"
						bindValue="id"
					></ng-select>
				</div>
				<h5 class="card-title col-sm-12">Konfiguracja ceny średniej</h5>
				<div class="mb-3 col-sm-12">
					<!-- <label for="queryPriceList">Cenniki</label>
					<app-checkboxes
						[items]="priceLists"
						[(values)]="
							offer.queryPriceListAverage
						"
					></app-checkboxes> -->

					<table class="table table-striped table-hover table-bordered table-sm">
						<thead>
							<tr>
								<th>Nazwa</th>
								<th>Tak/Nie</th>
							</tr>
						</thead>

						<tbody>
							<tr *ngFor="let item of priceLists; let id = index">
								<td>
									{{ item.name }}
								</td>
								<td>
									{{ item.type }}
								</td>
								<td>
									<select
										type="text"
										class="form-select"
										name="idCount_{{ id }}"
										[(ngModel)]="item.countToStatistic"
										(change)="save(item)"
									>
										<option [value]="kind.idCount" *ngFor="let kind of countToStatistic">
											{{ kind.name }}
										</option>
									</select>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</form>
</div>
